import { useState } from "react"
import Button from "@/v2-backoffice-client/components/button"
import type { UserFragment } from "@/v2-backoffice-client/user/__types__/user.fragment"
import UserContactBadge from "@/v2-backoffice-client/user/contact/UserContactBadge"
import UserContactSyncDialog from "@/v2-backoffice-client/user/contact/sync/UserContactSyncDialog"
import { getContactSyncFix } from "@/v2-backoffice-client/user/contact/userContact.constants"

export type UserContactSyncCellProps = {
  user: UserFragment
  showHealthy?: boolean
}

// Renders the HubSpot badge plus its repair affordance — the CRM sibling
// of UserIdentityCell. The sync button is handed to the badge tooltip,
// but the dialog it opens is rendered HERE as a SIBLING of the badge —
// never inside the tooltip. Tooltip content is unmounted when the tooltip
// closes, so a dialog mounted inside it would dismount the moment the
// pointer leaves the badge; keeping the dialog out here lets it outlive
// the tooltip.
function UserContactSyncCell(props: UserContactSyncCellProps) {
  const { user, showHealthy } = props
  const fix = getContactSyncFix(user.ContactSyncStatus)
  const [open, setOpen] = useState(false)

  const action = fix ? (
    <Button variant="outline" size="xs" onClick={() => setOpen(true)}>
      Sync to HubSpot
    </Button>
  ) : undefined

  return (
    <>
      <UserContactBadge user={user} showHealthy={showHealthy} action={action} />
      {fix === "sync" && (
        <UserContactSyncDialog
          userId={user.Id}
          email={user.Email}
          open={open}
          onOpenChange={setOpen}
        />
      )}
    </>
  )
}

export default UserContactSyncCell
